
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ckan/support",
      function () {
        return require("private-next-pages/solutions/ckan/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ckan/support"])
      });
    }
  